<template>
    <div id="app">
        <Header></Header>
        <!-- <router-view/> -->
        <router-view v-if="isRouterAlive"></router-view>
        <Footer></Footer>
        <div id="test" @click="goTop()" ref="btn">
        <img src="./assets/images/top.png" alt=""></div>

    </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { Toast } from "mint-ui";
export default {
  components: {
    Header,
    Footer
  },
  provide() {
    return {
      reload: this.reload,
      showMsg: this.showMsg,
      replaceHtml: this.replaceHtml,
      stopPropagation: this.stopPropagation
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
    window.addEventListener("scroll", this.needScroll());
    window.addEventListener(
      "resize",
      function(event) {
        const size = screen.width > screen.height ? "landscape" : "portrait";
        // // landscape 横屏  portrait 竖屏
        // const size = (document.documentElement.clientWidth ==  document.documentElement.clientHeight) ?"landscape" : "portrait";
        // console.log( screen.height);
        if (size === "landscape") {
          layer.open({
            content: "横屏体验不好，请使用竖屏查看本网页",
            btn: "我知道了"
          });
        } else {
          // console.log('正常')
        }
      },
      false
    );
  },
  methods: {
    reload: function() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    showMsg(msg) {
      Toast({
        message: msg,
        duration: 1000
      });
    },
    needScroll() {
      let obtn = this.$refs.btn;
      window.onscroll = function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop; //滚动的高度
        if (osTop >= 20) {
          obtn.style.display = "block";
        } else {
          obtn.style.display = "none";
        }
      };
    },
    goTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      /*document.body.scrollTop == 0*/
      // document.body.scrollTop = 0;
      // this.timer = setInterval(()=> {
      //     let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      //    /* let isPeed = Math.floor(-osTop / 10);*/
      //     document.documentElement.scrollTop = document.body.scrollTop = 0;
      //     if (document.documentElement.scrollTop === 0) {
      //         clearInterval(this.timer);
      //         // console.log('点击完了哦');
      //     }
      // }, 30);
    },
    replaceHtml(text) {
      const txt = this.htmlDecode(text).replace(
        /src="\/public/g,
        'src="' + this.weburl + "/public"
      );
      // console.log(txt);
      return txt;
    },
    stopPropagation(e) {
      e = e || window.event;
      if (e.stopPropagation) {
        //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.needScroll);
  },
  computed: {
    //计算属性，
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>


<style lang="less" scoped>
#app {
  margin-top: 44px;
}
@media screen and (max-width: 1020px) and (orientation: landscape) {
  #app {
    width: 100vh !important;
    overflow-x: hidden;
    margin: 44px auto 0;
  }
}
#test {
  position: fixed;
  right: 10px;
  bottom: 160px;
  z-index: 999;
  display: none;
  width: 40px;
  @media (max-width: 360px) {
    bottom: 172px;
  }
  @media (max-width: 320px) {
    bottom: 176px;
  }
  img {
    width: 100%;
  }
}

@media (min-width: 768px) and (orientation: portrait) {
  #app {
    margin-top: 70px;
  }

  #test {
    width: 60px;
    bottom: 170px;
  }
}
</style>
